import { createClient, RedisClientType } from "redis";

const endpoint = process.env.REDISCLOUD_URL;

export default class RedisPool {
  private static readonly MAX_CONNECTION = 10;
  private static pool: RedisClientType[] = [];

  public static async GetConnection(): Promise<RedisClientType> {
    if (RedisPool.pool.length > 0) {
      const connection = RedisPool.pool.pop();

      if (connection) return connection;
    }

    const newConnection: RedisClientType = createClient({
      url: endpoint,
      username: process.env.REDISCLOUD_USERNAME,
      password: process.env.REDISCLOUD_PASSWORD,
    });

    try {
      await newConnection.connect();
    } catch (err) {
      throw new Error(`Erro ao conectar no Redis - ${err}`);
    }

    return newConnection;
  }

  public static releaseConnection(connection: RedisClientType): void {
    if (!endpoint || !connection.isOpen) return;

    if (RedisPool.pool.length < RedisPool.MAX_CONNECTION) {
      RedisPool.pool.push(connection);
    } else {
      connection.quit();
    }
  }
}
